import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import classNames from "classnames";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";

var NavList = function NavList(_ref) {
  var children = _ref.children,
      title = _ref.title,
      handleItemClick = _ref.handleItemClick,
      isExpanded = _ref.isExpanded;
  var getClassName = getClassNameFactory("SiteFooterNavList");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      states: classNames({
        expanded: isExpanded
      })
    }),
    "data-rehydratable": getRehydratableName(NavList.displayName),
    "data-title": title
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames(getClassName({
      descendantName: "title"
    }), getClassName({
      descendantName: "mobileShow"
    })),
    onClick: function onClick() {
      return handleItemClick(title);
    },
    role: "button",
    "aria-label": "Thomson Reuters",
    "aria-haspopup": true,
    "aria-expanded": isExpanded
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "text"
    })
  }, /*#__PURE__*/React.createElement("p", null, title), isExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null))), /*#__PURE__*/React.createElement("h3", {
    className: classNames(getClassName({
      descendantName: "title"
    }), getClassName({
      descendantName: "desktopShow"
    }))
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "text"
    })
  }, title)), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children));
};

NavList.displayName = "SiteFooter.NavList";
NavList.defaultProps = {
  isExpanded: false,

  /**
   * assign noop to surpress `tsc` possibly "undefined" err
   * this prop is supplied by `SiteFooter`
   */
  handleItemClick: function handleItemClick() {}
};
export default NavList;